// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WhatsappMessageTemplates_RemoverWhatsappMessageTemplateResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/whatsapp_message_templates/remover_whatsapp_message_template/{template_id}.
 *
 * Pure mutation — emits no payload on success. Errors flow through sendError().
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WhatsappMessageTemplates_RemoverWhatsappMessageTemplateResponseDados = null;

export type WhatsappMessageTemplates_RemoverWhatsappMessageTemplateResponse = ApiResponse<WhatsappMessageTemplates_RemoverWhatsappMessageTemplateResponseDados>;

registerResponseContract('WhatsappMessageTemplates_RemoverWhatsappMessageTemplateResponse', {})
